const url = "https://music.apple.com/us/playlist/atl-summer/pl.u-WabZE5YfekaqYox"
const title = "music"
const frank = "https://www.timeglotch.com/"
const frTitle = "Frank"
export const STOP_CONTENT = {
  about: {
    title: "About Me",
    body: (<span>
{`Hi, my name is Cam! I'm currently located in Atlanta, although I've lived all over the US. I obtained my bachelor's of science in Computer Science and Linguistics at the University of Wisconsin-Madison.

There, I dabbled in everything from studies to shenanigans, the latter of which will hopefully continue into the foreseeable future.

Having spent most of my pre-collegiate life in decidely non-STEM environments, I was terrified to pursue computer science, but I grew up with computers. Why not try to pick them apart? 

My computer was the place where I discovered idea that I could have never imagined, and later, the place where I could create new ones.
`} 
    </span>
    )
  },
  background: {
    title: "Background",
    body: `
- Systems Engineer @ AT&T (Atlanta, GA)
`
  },
  interests: {
    title: "Interests",
    body: (
<span>
  {`
  - computer networks, cryptography
  - psycholinguistics (send cool papers!)
  - running
  - journaling (non-aesthetically)
  - making mediocre beats
  -`} <a href={url} target="_blank" rel="noopener noreferrer">{title}</a>
</span>)
  },
  research: {
    title: "Research",
    body: `
    Brain, Language, and Acoustic Behavior Lab (Jan 2024 - August 2025)
    - I contributed to speech motor planning experiments investigating whether altered auditory feedback improves speech intelligibility. While working with participants, I got to see all these elements fuse together and help understand and (hopefully) help Parkinson's patients. Pretty neat stuff.

      Lupyan Lab (Sept 2025 - Feb 2026)
  - I was curious about how well LLMs could reason compared to humans. Turns out, they suck, but so do humans. A short but fun stint that involved poking into model inference. Little bit of Python, little bit of framework tinkering.
`
  },
  work: {
    title: "Work",
    body:
`
Research Assistant @ University of Wisconsin-Madison (June - August 2025)
• This entailed quite a bit of combing through MATLAB, formant tracking (adjust audio track but make it linguistically sound), and patience. 


Web Developer Intern @ Internet Scout Research Group (June 2024 - Aug 2024)
University of Wisconsin-Madison
• Porting legacy code to something more maintainable.`
  },
  projects: {
    title: "Projects",
    body: (
      <span>
      {`
Arc Log Whisperer | GE HealthCare Capstone (January - May 2026)
• A necessary preface: thank you to my mentors, team, and a litany of GE HealthCare engineers for this experience. Much love to the Careful Whisperers!

Think: search engine but for medical device logs to optimize debugging.

Load the site and see our TypeScript frontend, supporting multi-file log upload and parsing. Upload the file, and behind the scenes, our backend prepares it for ingestion. Done. Man to man, API to API, we call OpenSearch to clean up the data.

Then the fun part - you can now execute aggregation and filtering queries against the indexed data and see the results. To view more info, use the log context viewer to automatically highlight and jump to alarm occurrences within cleaned log files.

VOCAL-ize (January - August 2025):
•  With Annika, the visionary behind it all and a wonderful collaborator, and`} <a href={frank} target="_blank" rel="noopener noreferrer">{frTitle}</a>, my friend and fellow CS/Linguistics grad, we shipped a React web app used by intro Spanish classes to record, analyze, and visualize speech in real time for language learning. 
We built a real-time audio pipeline (Web Audio API) to stream microphone input; applied signal processing algorithms (smoothing, filtering,
and pre-emphasis) to stabilize real-time analysis visualizations for pronunciation feedback (LPC-based spectral envelopes).
Started with Figma and ended up deploying it to a Spanish undergrad course. What a journey.

  </span>
  
)
  }
}